export default function Slack() {
  return (
    <>
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 99 26"
        width={99}
        height={26}
        className="hidden md:block"
      >
        <title>Slack</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.672 20.617l1.235-2.87c1.335.997 3.113 1.516 4.867 1.516 1.295 0 2.115-.5 2.115-1.255-.02-2.115-7.758-.46-7.817-5.762-.02-2.693 2.372-4.768 5.762-4.768 2.015 0 4.027.499 5.464 1.635l-1.156 2.93c-1.315-.839-2.95-1.437-4.506-1.437-1.058 0-1.755.5-1.755 1.137.02 2.075 7.817.938 7.897 6.003 0 2.752-2.333 4.689-5.683 4.689-2.455-.004-4.708-.582-6.423-1.818zm47.445-3.908a3.586 3.586 0 01-3.113 1.813 3.564 3.564 0 01-3.568-3.568 3.566 3.566 0 013.568-3.568c1.335 0 2.495.737 3.113 1.814l3.41-1.893c-1.276-2.273-3.731-3.83-6.523-3.83a7.482 7.482 0 000 14.96 7.436 7.436 0 006.522-3.828l-3.41-1.9zM45.492 1.273h4.27v20.88h-4.27V1.274zm38.71 0v20.88h4.268V15.89l5.065 6.265H99l-6.443-7.441L98.52 7.77h-5.228l-4.827 5.762V1.273h-4.265z"
          fill="#9DA6C7"
        />
        <path
          d="M62.446 16.748c-.618 1.018-1.893 1.774-3.33 1.774a3.563 3.563 0 01-3.569-3.568 3.566 3.566 0 013.568-3.568c1.438 0 2.713.796 3.33 1.834v3.528zm0-8.973V9.47c-.697-1.176-2.432-1.996-4.25-1.996-3.75 0-6.7 3.31-6.7 7.46s2.95 7.5 6.7 7.5c1.814 0 3.549-.815 4.25-1.995v1.695h4.268V7.774h-4.268z"
          fill="#9DA6C7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.287 16.728a2.63 2.63 0 01-2.633 2.634A2.632 2.632 0 01.02 16.728a2.632 2.632 0 012.633-2.633h2.633v2.633zm1.315 0a2.63 2.63 0 012.633-2.633 2.63 2.63 0 012.634 2.633v6.582a2.63 2.63 0 01-2.634 2.633 2.63 2.63 0 01-2.633-2.633v-6.582zM9.235 6.16A2.63 2.63 0 016.6 3.525 2.63 2.63 0 019.235.892a2.63 2.63 0 012.633 2.634v2.633H9.235zm0 1.334a2.63 2.63 0 012.633 2.633 2.63 2.63 0 01-2.633 2.634H2.633A2.632 2.632 0 010 10.127a2.632 2.632 0 012.633-2.633h6.602zM19.785 10.127a2.63 2.63 0 012.633-2.633 2.63 2.63 0 012.634 2.633 2.63 2.63 0 01-2.634 2.634h-2.633v-2.634zm-1.315 0a2.63 2.63 0 01-2.633 2.634 2.63 2.63 0 01-2.634-2.634V3.526A2.63 2.63 0 0115.836.892a2.63 2.63 0 012.634 2.634v6.601zM15.836 20.677a2.63 2.63 0 012.634 2.633 2.63 2.63 0 01-2.633 2.633 2.63 2.63 0 01-2.634-2.633v-2.633h2.633zm0-1.315a2.63 2.63 0 01-2.633-2.634 2.63 2.63 0 012.633-2.633h6.602a2.63 2.63 0 012.633 2.633 2.63 2.63 0 01-2.633 2.634h-6.601z"
          fill="#9DA6C7"
        />
      </svg>

      <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="md:hidden"
      >
        <g
          clipPath="url(#Slack_svg__clip0)"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#9DA6C7"
        >
          <path d="M15.196 3a3.329 3.329 0 00-3.326 3.332 3.33 3.33 0 003.327 3.333h3.327V6.334A3.332 3.332 0 0015.196 3zm0 8.888h-8.87A3.33 3.33 0 003 15.22a3.33 3.33 0 003.325 3.334h8.87a3.33 3.33 0 003.328-3.332 3.33 3.33 0 00-3.327-3.334zM36.263 15.22a3.33 3.33 0 00-3.327-3.332 3.33 3.33 0 00-3.327 3.332v3.334h3.327a3.33 3.33 0 003.327-3.334zm-8.87 0V6.332A3.33 3.33 0 0024.067 3a3.33 3.33 0 00-3.327 3.332v8.888a3.33 3.33 0 003.326 3.334 3.33 3.33 0 003.327-3.334zM24.066 36.33a3.33 3.33 0 003.327-3.332 3.33 3.33 0 00-3.327-3.333h-3.327v3.333a3.331 3.331 0 003.327 3.332zm0-8.89h8.87a3.33 3.33 0 003.327-3.332 3.33 3.33 0 00-3.325-3.333h-8.87a3.33 3.33 0 00-3.328 3.332 3.329 3.329 0 003.326 3.334zM3 24.108a3.33 3.33 0 003.327 3.333 3.33 3.33 0 003.327-3.333v-3.332H6.327A3.33 3.33 0 003 24.108zm8.87 0v8.888a3.33 3.33 0 003.326 3.334 3.33 3.33 0 003.327-3.332V24.11a3.327 3.327 0 10-6.652-.003s0 .002 0 0z" />
        </g>
        <defs>
          <clipPath id="Slack_svg__clip0">
            <path
              fill="#fff"
              transform="translate(3 3)"
              d="M0 0h33.263v33.33H0z"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
